var dfs = require("./dfs");
module.exports = preorder;
function preorder(g, vs) {
  return dfs(g, vs, "pre");
}